module.exports = __webpack_public_path__ + "site/img/65.aaf25395.jpg";